import React, { useEffect, useState } from 'react';
import './Community.css'
import Select from 'react-select';
import Carousel from 'react-bootstrap/Carousel';
import { Link } from 'react-router-dom';
import { Popup } from "semantic-ui-react";
import DatePicker from 'react-datepicker';
import CreatePost from './CreatePost';
import { useSelector } from 'react-redux';
import axios from "../../axios"
import { useLocation } from 'react-router-dom';



export default function EngagementCommunity() {
  const currentUser = useSelector((state) => state.user.currentUser);
  const navigate = useLocation()
  const [engagmentComunityMain, setEngagmentComunityMain] = useState({
    showComment: false,
    filterDetails: false,
    createPost: false,
    statusPost: 'accepted'
  })

  // handle fun false createPost
  const handleFalseCreatePost = (e) => {
    setEngagmentComunityMain({
      ...engagmentComunityMain,
      createPost: false
    })
  };

  // useEffect(() => {
  //   const getCommunity = async () => {
  //     try {
  //       const resp = await axios.get(
  //         `/community/getByUserId/student/${currentUser.id}`
  //       );
  //       console.log("resp.data.data", resp.data.data)
  //       const communityId = resp.data.data[0].id
  //       resp && navigate("/EngagementCommunity", { state: { communityId } });
  //     } catch (error) { }
  //   };
  //   getCommunity();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentUser.id, navigate]);



  // drodowon css
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      height: '32px',
      width: '172px',
      borderRadius: '6px',
      padding: ' 1px',
      border: '1px solid #F4F8FB',
      fontFamily: "MinecrafterReg.ttf",
      background: '#F8F9FD',
      fontSize: '12px'
    }),
    menu: (provided, state) => ({
      ...provided,
      // width: state.selectProps.menuWidth || 'auto', // Set the width to 10px when menuWidth is set
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: 'white',
      fontSize: '12px',
      color: 'black', // Change the background color when the option is hovered over
      '&:hover': {
        boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.1)',
        color: '#F77F00',
        borderRadius: '5px',
        fontWeight: '600'

      },
    }),
    indicatorSeparator: () => ({ display: "none" }),
  };
  const optionsQuery = [
    { value: 'Name', label: 'Name' },
    { value: 'Tag', label: 'Tag' },
  ];
  const [selectedOption, setSelectedOption] = useState(null);
  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
  };

  // for show more and hide text 
  const [showFullText, setShowFullText] = useState(false);

  const toggleShowFullText = () => {
    setShowFullText(!showFullText);
  };

  const text = "The expo begins with an account of account of science in ancient India and the country's  in the pre-Independence science in ancient India and the country's achievements in the pre-Independence period...";

  const trimmedText = showFullText ? text : text.slice(0, 110) + '...';
  const seeMoreLink = text.length > 100 ? (
    <span onClick={toggleShowFullText} className="see-more-link">
      {showFullText ? "Hide" : "See More"}
    </span>
  ) : null;


  // below code for like and like 
  const formatLikeCount = (count) => {
    if (count >= 1000) {
      return (count / 1000).toFixed(1) + 'k';
    }
    return count;
  };

  const [isLiked, setIsLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(1200); // Start with 1.2k Likes

  const handleLikeClick = () => {
    if (isLiked) {
      setLikeCount(likeCount - 1);
    } else {
      setLikeCount(likeCount + 1);
    }
    setIsLiked(!isLiked);
  };



  // for edit the comment 
  const [editable, setEditable] = useState(false);
  const [nameTimeValue, setNameTimeValue] = useState(
    'Lorem Ipsum is simply dummy text of the printing and typesetting'
  );

  // Function to handle Edit button click
  const handleEditClick = () => {
    setEditable(!editable);
  };

  // Function to handle changes in the input field
  const handleInputChange = (e) => {
    setNameTimeValue(e.target.value);
  };

  // handle filter icons 
  const handleFilterDeetail = () => {
    if (engagmentComunityMain.filterDetails) {
      setEngagmentComunityMain({
        ...engagmentComunityMain,
        filterDetails: false
      })
    } else {
      setEngagmentComunityMain({
        ...engagmentComunityMain,
        filterDetails: true
      })
    }
  }

  // handle post status timer 
  useEffect(() => {
    // This function will run when the component is mounted
    const timer = setTimeout(() => {
      setEngagmentComunityMain({ ...engagmentComunityMain, statusPost: '' }); // Set the state to false after 3 seconds
    }, 5000);

    // This function will run when the component is unmounted
    return () => clearTimeout(timer);
  }, [engagmentComunityMain.statusPost]); // The empty dependency array ensures the effect runs only once on mount


  return (
    <div className='row TotalContainerEgagement'>
      <div className='d-flex justify-content-between  '>
        <div className='d-flex gap-3'>
          <div className=' topickHeading'>Topics</div>
          <div className='d-flex gap-2 flex-wrap containerTopic'>
            <div className='topicBox'>Maths (50)</div>
            <div className='topicBox'>Exhibition (45)</div>
            <div className='topicBox'>Social Expo 2022 (40)</div>
            <div className='topicBox'>Exhibition(50)</div>
            <div className='topicBox'>Science Workshop (25)</div>
            <div className='topicBox'>Question Banks (35)</div>
            <div className='topicBox'>Social Expo 2022 (40)</div>
            <div className='topicBox'>Exhibition(50)</div>
            <div className='topicBox'>Science Workshop (25)</div>
            <div className='topicBox'>Question Banks (35)</div>
            <div className='topicBox'>Exhibition (45)</div>
            <div className='topicBox'>Exhibition (45)</div>
            <div className='topicBox'>Exhibition (45)</div>
            <div className='topicBox'>Exhibition (45)</div>

          </div>
        </div>

        <div className='mt-2 '>
          {/* below code for show Post Status  */}
          {engagmentComunityMain.statusPost === 'declined' && <div className='PostStatusContainer'>
            <img src='/Enggagement/declinedPostImg.png' alt=''></img>
          </div>}
          {engagmentComunityMain.statusPost === 'review' && <div className='PostStatusContainer'>
            <img src='/Enggagement/reviewPostImg.png' alt=''></img>
          </div>}
          {engagmentComunityMain.statusPost === 'accepted' && <div className='PostStatusContainer'>
            <img src='/Enggagement/AcceptedPostImg.png' alt=''></img>
          </div>}

          <button className='postComunityBtn' onClick={(e) => { setEngagmentComunityMain({ ...engagmentComunityMain, createPost: true }) }}>Post to community</button>
        </div>

      </div>



      <div className='row'>

        <div className='col-md-8'>
          <div className='row '>
            <div className='col-md-10'>
              <div className='containerForSerchFilterEngg  d-flex align-items-center'>
                <div>
                  <Select
                    options={optionsQuery}
                    value={selectedOption}
                    onChange={handleChange}
                    placeholder="Select Search Type"
                    styles={customStyles}
                  />
                </div>
                <input className='serchQuryInputtEngg'></input>
                <div className='d-flex align-items-center'>
                  <div>
                    <img src='/Enggagement/SearchIconQuery.png' alt=''></img>
                  </div>
                  <Popup
                    on="click"
                    className="popUpFilter"
                    trigger={
                      <div className='mr-1' style={{ cursor: 'pointer' }}>
                        <img src='/Enggagement/FilterIconQuery.png' alt=''></img>
                      </div>
                    }
                    content={
                      <div className='filterCommuity p-3' >
                        <div className='d-flex justify-content-between w-100' onClick={handleFilterDeetail}>
                          <span className='filterHeading'>Filter</span>
                          <div>
                            {engagmentComunityMain.filterDetails ? <img src='/Enggagement/upArrow.png' alt=''></img>
                              : <img src='/Enggagement/downArrow.png' alt=''></img>}
                          </div>
                        </div>
                        {engagmentComunityMain.filterDetails &&
                          <>
                            <div className='p-2'>
                              <div className='d-flex align-items-center gap-1'>
                                <input type='checkbox' id='inputCheckbox' /> &nbsp;
                                <span className='dayForFilter'>Today </span>
                              </div>

                              <div className='d-flex align-items-center gap-1'>
                                <input type='checkbox' id='inputCheckbox' /> &nbsp;
                                <span className='dayForFilter'>Yesterday </span>
                              </div>
                              <div className='d-flex align-items-center gap-1'>
                                <input type='checkbox' id='inputCheckbox' /> &nbsp;
                                <span className='dayForFilter'>This Week </span>
                              </div>
                              <div className='d-flex align-items-center justify-content-between'>
                                <div className='d-flex align-items-center gap-2'>
                                  <img src='/Enggagement/clanederIconFilter.png' alt='' />
                                  <span className='dayForFilter ml-1 '>Pick a Date </span>
                                </div>
                                <div>
                                  <img src='/Enggagement/rightArrow.png' alt='' />
                                </div>
                              </div>

                            </div>

                            <div className='d-flex justify-content-between mt-1'>
                              <button className='buttonsfilter'>Clear</button>
                              <button className='buttonsfilter2'>Apply</button>
                            </div>
                          </>
                        }
                      </div>
                    }
                    position="bottom center"
                  />

                </div>
              </div>


              <div className='d-flex gap-2 mt-3'>
                <div>
                  <img src='/Enggagement/ProifleCommunity.png' alt='' />
                </div>
                <div >
                  <div className='d-flex align-tems-center gap-2'>
                    <div className='ComunityName '>John Doe 4-B</div>
                    <div className='TopicCommunityBox'>Exhibition</div>
                    <div className='TopicCommunityBox'>Social Expo 2022</div>
                  </div>
                  <div className='NameTime'>
                    Xploresense School | Today 04:30 pm
                  </div>
                </div>
              </div>
              <p className='mt-2'>
                <span className='captionText'>
                  {trimmedText}
                </span>
                <span className='seeMoreText'>{seeMoreLink}</span>
              </p>

              <div className='sildeImgContainer'>
                <Carousel>
                  <Carousel.Item>
                    <img className='imgPostComunity' src='/Enggagement/ComunityPostImg.png' alt='' preload='auto' />
                  </Carousel.Item>
                  <Carousel.Item>
                    <img className='imgPostComunity' src='/Enggagement/ComunityPostImg.png' alt='' preload='auto' />
                  </Carousel.Item>
                  <Carousel.Item>
                    <img className='imgPostComunity' src='/Enggagement/ComunityPostImg.png' alt='' preload='auto' />
                  </Carousel.Item>
                </Carousel>
              </div>
              <div className='d-flex justify-content-between mt-3'>

                <span onClick={handleLikeClick}>
                  {isLiked ? (
                    <img src='/Enggagement/likedComuity.png' style={{ cursor: 'pointer' }} alt='' />
                  ) : (
                    <img src='/Enggagement/UnlikeComunity.png' style={{ cursor: 'pointer' }} alt='' />
                  )}
                  <span className='likesComment ml-1'>{formatLikeCount(likeCount)} Likes</span>
                </span>

                <span style={{ cursor: 'pointer' }} onClick={(e) => { setEngagmentComunityMain({ ...engagmentComunityMain, showComment: true }) }}>
                  <img src='/Enggagement/CommentIconComunity.png' alt='' />
                  <span className='likesComment ml-1'>3.3K Comments</span>
                </span>
              </div>
              {engagmentComunityMain.showComment &&
                <>
                  <div className='mt-2 '>
                    <div className='containerInputComment d-flex align-itmes-center'>
                      <input placeholder='Write your comment' className='commentInput' />
                      <div className='pt-1'>
                        <img src='/Enggagement/SendImg.png' alt='' />
                      </div>
                    </div>
                  </div>

                  <div className='mt-2'  >
                    <span className='commentHeading1'>Comments </span><span className='commentHeading'>(2.2K)</span>
                  </div>



                  <div>
                    <Popup
                      on="click"
                      className="popUpFilter"
                      trigger={
                        <div className='d-flex gap-2 align-itmes-center mt-3' >
                          <div>
                            <img src='/Enggagement/ProifleCommunity.png' alt='' />
                          </div>
                          <div className='w-100' >
                            <div className='ChannelNameComunity'>
                              Can Berk Cilek
                              &nbsp; <span className='commentDatetime'>4th class | 24 Jan | 4:30 pm</span>
                            </div>
                            <div className='d-flex gap-3 '>
                              <div className='NameTime w-100'>
                                {editable ? (
                                  <textarea
                                    className='commentEditeInput'
                                    type='text'
                                    value={nameTimeValue}
                                    onChange={handleInputChange}
                                  />
                                ) : (
                                  nameTimeValue
                                )}
                              </div>
                              {editable && <div className='d-flex gap-3'>
                                <div className='d-flex gap-2'
                                  style={{ cursor: 'pointer' }}
                                  onClick={(e) => setEditable(false)}
                                >
                                  <div>
                                    <img style={{ cursor: 'pointer' }}

                                      src='/LibraryImg/EditDone.png' alt='replie icon' />
                                  </div>
                                  <span>Done</span>
                                </div>
                                <div className='d-flex gap-2'>
                                  <div>
                                    <img style={{ cursor: 'pointer' }}

                                      src='/LibraryImg/EditDiscard.png' alt='replie icon' />
                                  </div>
                                  <span>Discard</span>
                                </div>
                              </div>}
                            </div>
                          </div>
                        </div>
                      }
                      content={
                        <div className='container_threedot p-3'>
                          <div className='PopupThreedots p-1 d-flex align-items-center gap-3' onClick={handleEditClick}>
                            <div className='d-flex align-items-center'>
                              <img src='/Enggagement/EditeIconPoup.png' alt='' />
                            </div>
                            <div style={{ fontSize: '12px' }}>Edit</div>
                          </div>
                          <div className='PopupThreedots p-1 d-flex align-items-center gap-3'>
                            <div className='d-flex align-items-center'>
                              <img src='/Enggagement/deleteIconPoup.png' alt='' />
                            </div>
                            <div style={{ fontSize: '12px' }}>Delete</div>
                          </div>
                        </div>
                      }
                      position="bottom center"
                    />

                    <div className='d-flex gap-2 align-itmes-center mt-3' >
                      <div>
                        <img src='/Enggagement/ProifleCommunity.png' alt='' />
                      </div>
                      <div >
                        <div className='ChannelNameComunity'>
                          Can Berk Cilek
                          &nbsp; <span className='commentDatetime'>4th class | 24 Jan | 4:30 pm</span>
                        </div>
                        <div className='NameTime'>
                          Lorem Ipsum is simply dummy text of the printing and typesetting
                        </div>

                      </div>
                    </div>
                    <div className='d-flex gap-2 align-itmes-center mt-3' >
                      <div>
                        <img src='/Enggagement/ProifleCommunity.png' alt='' />
                      </div>
                      <div >
                        <div className='ChannelNameComunity'>
                          Can Berk Cilek
                          &nbsp; <span className='commentDatetime'>4th class | 24 Jan | 4:30 pm</span>
                        </div>
                        <div className='NameTime'>
                          Lorem Ipsum is simply dummy text of the printing and typesetting
                        </div>
                      </div>
                    </div>
                    <div className='d-flex gap-2 align-itmes-center mt-3' >
                      <div>
                        <img src='/Enggagement/ProifleCommunity.png' alt='' />
                      </div>
                      <div >
                        <div className='ChannelNameComunity'>
                          Can Berk Cilek
                          &nbsp; <span className='commentDatetime'>4th class | 24 Jan | 4:30 pm</span>
                        </div>
                        <div className='NameTime'>
                          Lorem Ipsum is simply dummy text of the printing and typesetting
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='viewMoreText mt-3'>View more comments</div>
                </>
              }

            </div>

            <div className='col-md-2'>
              <div className='clearSerachTxt mt-3 '>
                Clear Search
              </div>
            </div>
          </div>

        </div>


        <div className='col-md-4'>


          <div className='channelsHeading'>Channels</div>

          <div className='channelContainerAll'>
            <Link to='/GroupDetailsCommunity' className='link'><div className='d-flex gap-2 align-itmes-center mt-3 ' >
              <div>
                <img src='/Enggagement/ProifleCommunity.png' alt='' />
              </div>
              <div >
                <div className='ChannelNameComunity'>
                  Xploresense Science Channel
                </div>
                <div className='NameTime'>
                  Created by School   |   12,000+ Posts
                </div>
              </div>
            </div>
            </Link>
            <div className='d-flex gap-2 align-itmes-center mt-3' >
              <div>
                <img src='/Enggagement/ProifleCommunity.png' alt='' />
              </div>
              <div >
                <div className='ChannelNameComunity'>
                  Xploresense Science Channel
                </div>
                <div className='NameTime'>
                  Created by School   |   12,000+ Posts
                </div>
              </div>
            </div>
            <div className='d-flex gap-2 align-itmes-center mt-3' >
              <div>
                <img src='/Enggagement/ProifleCommunity.png' alt='' />
              </div>
              <div >
                <div className='ChannelNameComunity'>
                  Xploresense Science Channel
                </div>
                <div className='NameTime'>
                  Created by School   |   12,000+ Posts
                </div>
              </div>
            </div>
            <div className='d-flex gap-2 align-itmes-center mt-3' >
              <div>
                <img src='/Enggagement/ProifleCommunity.png' alt='' />
              </div>
              <div >
                <div className='ChannelNameComunity'>
                  Xploresense Science Channel
                </div>
                <div className='NameTime'>
                  Created by School   |   12,000+ Posts
                </div>
              </div>
            </div>
          </div>


        </div>

      </div>
      {engagmentComunityMain.createPost && <CreatePost handleFalseCreatePost={handleFalseCreatePost} />}



    </div>
  )
}
